import { Directive, ElementRef, Input } from '@angular/core';

/**
 * bar pin 왼쪽 여백을 주어 이동 효과를 줌
 * 주어진 값 - pin width / 2로 설정하여 중앙에 위치할 수 있도록 함
 */
@Directive({
  selector: '[margin-left]',
})
export class MarginLeft {
  private $el: HTMLElement;

  constructor(el: ElementRef) {
    this.$el = el.nativeElement;
  }

  @Input('margin-left') set marginLeft(width: number) {
    const calculated = width - (this.$el.offsetWidth / 2);
    this.$el.style.marginLeft = `${calculated}px`;
  }
}

/**
 * bar 이미지에 css - clip을 조정하여 cropping 효과를 줌
 */
@Directive({
  selector: '[clip-right]',
})
export class ClipRight {
  private $el: HTMLElement;

  constructor(el: ElementRef) {
    this.$el = el.nativeElement;
  }

  @Input('clip-right') set clipRight(width: number) {
    this.$el.style.clip = `rect(0 ${width}px 100px 0)`;
  }
}

/**
 * 지정한 타입에 따라 bar 이미지 변경 0, 1, 그 외는 마지막 요소
 */
@Directive({
  selector: '[pin-type]',
})
export class PinImage {
  private $el: HTMLElement;
  private $map: string[] = [
    'assets/images/bbreport_pin_01.png',
    'assets/images/bbreport_pin_02.png',
    'assets/images/bbreport_pin_03.png',
  ];

  constructor(el: ElementRef) {
    this.$el = el.nativeElement;
  }

  @Input('pin-type') set pinType(type: number) {
    const last = this.$map.length - 1;
    this.$el['src'] = type > last ? this.$map[last] : this.$map[type];
  }
}
